export class Preview {
  regenerate(options) {
    var _options$abortControl;
    return this.repository.executeAction({
      name: 'RegeneratePreviews',
      idOrPath: options.idOrPath,
      method: 'POST',
      body: undefined,
      requestInit: {
        signal: (_options$abortControl = options.abortController) === null || _options$abortControl === void 0 ? void 0 : _options$abortControl.signal
      }
    });
  }
  async available(options) {
    var _options$abortControl2;
    const responseBody = await this.repository.executeAction({
      idOrPath: options.document.idOrPath,
      method: 'POST',
      name: 'PreviewAvailable',
      oDataOptions: {
        version: options.version
      },
      body: {
        page: options.page
      },
      requestInit: {
        signal: (_options$abortControl2 = options.abortController) === null || _options$abortControl2 === void 0 ? void 0 : _options$abortControl2.signal
      }
    });
    if (responseBody.PreviewAvailable) {
      responseBody.PreviewImageUrl = `${options.document.hostName}${responseBody.PreviewAvailable}`;
      responseBody.ThumbnailImageUrl = `${options.document.hostName}${responseBody.PreviewAvailable.replace('preview', 'thumbnail')}`;
      return responseBody;
    }
  }
  async getExistingImages(options) {
    if (options.document.pageCount && options.document.pageCount < -1) {
      throw Error('Preview generation error');
    }
    if (options.document.idOrPath && options.document.hostName && options.document.pageCount) {
      var _options$abortControl3;
      const response = await this.repository.executeAction({
        idOrPath: options.document.idOrPath,
        name: `GetExistingPreviewImages`,
        method: 'POST',
        body: {},
        oDataOptions: {
          select: 'all',
          expand: 'all',
          version: options.version
        },
        requestInit: {
          signal: (_options$abortControl3 = options.abortController) === null || _options$abortControl3 === void 0 ? void 0 : _options$abortControl3.signal
        }
      });
      const availablePreviews = response.map(preview => {
        if (preview.PreviewAvailable) {
          preview.PreviewImageUrl = `${options.document.hostName}${preview.PreviewAvailable}`;
          preview.ThumbnailImageUrl = `${options.document.hostName}${preview.PreviewAvailable.replace('preview', 'thumbnail')}`;
        }
        return preview;
      });
      const allPreviews = [];
      for (let i = 0; i < options.document.pageCount; i++) {
        allPreviews[i] = availablePreviews[i] || {
          Index: i + 1
        };
      }
      return allPreviews;
    } else {
      return [];
    }
  }
  getPageCount(options) {
    var _options$abortControl4;
    return this.repository.executeAction({
      idOrPath: options.idOrPath,
      name: 'GetPageCount',
      method: 'POST',
      requestInit: {
        signal: (_options$abortControl4 = options.abortController) === null || _options$abortControl4 === void 0 ? void 0 : _options$abortControl4.signal
      }
    });
  }
  check(options) {
    var _options$abortControl5;
    return this.repository.executeAction({
      idOrPath: options.idOrPath,
      name: 'CheckPreviews',
      method: 'POST',
      body: {
        generateMissing: options.generateMissing
      },
      requestInit: {
        signal: (_options$abortControl5 = options.abortController) === null || _options$abortControl5 === void 0 ? void 0 : _options$abortControl5.signal
      }
    });
  }
  getComments(options) {
    var _options$abortControl6;
    return this.repository.executeAction({
      idOrPath: options.idOrPath,
      name: 'GetPreviewComments',
      method: 'GET',
      oDataOptions: {
        page: options.page
      },
      requestInit: {
        signal: (_options$abortControl6 = options.abortController) === null || _options$abortControl6 === void 0 ? void 0 : _options$abortControl6.signal
      }
    });
  }
  addComment(options) {
    var _options$abortControl7;
    return this.repository.executeAction({
      idOrPath: options.idOrPath,
      name: 'AddPreviewComment',
      method: 'POST',
      body: options.comment,
      requestInit: {
        signal: (_options$abortControl7 = options.abortController) === null || _options$abortControl7 === void 0 ? void 0 : _options$abortControl7.signal
      }
    });
  }
  deleteComment(options) {
    var _options$abortControl8;
    return this.repository.executeAction({
      idOrPath: options.idOrPath,
      name: 'DeletePreviewComment',
      method: 'POST',
      body: {
        id: options.commentId
      },
      requestInit: {
        signal: (_options$abortControl8 = options.abortController) === null || _options$abortControl8 === void 0 ? void 0 : _options$abortControl8.signal
      }
    });
  }
  constructor(repository) {
    this.repository = repository;
  }
}
//# sourceMappingURL=Preview.js.map